<template>
  <el-dialog title="Déplacer des rappels" :visible.sync="visible" :close-on-click-modal="false" width="30%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form" :rules="fields.validation">
      <el-form-item v-if="!form.meeting" prop="date" label="Date du rappel">
        <el-date-picker v-model="form.date" v-on:click.native="form.date = null; form.date = moment()" type="date"
                        placeholder="Selectionnez une date" class="form-control"
                        :picker-options="fields.date" format="dd/MM/yyyy">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Commercial" prop="user_id">
        <el-select v-model="form.user_id" class="form-control" placeholder="Select">
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="user.name"
            :value="user.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="this.form.id !== null" type="danger" :plain="true" v-on:click.native="visible = false" v-delete:reminder="this.form"
                 class="pull-left">Supprimer</el-button>
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button type="warning" v-on:click="submit()" :loading="button.loading">{{ button.text }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { MessageBox } from 'element-ui'
  import Customer from '../Entities/Customer.vue'
  import _ from 'lodash'
  import { events } from '../../model/utils/event-bus'

  export default {
    components: {Customer},
    name: 'move-reminders-modal',
    data () {
      return {
        visible: false,
        ids: [],
        fields: {
          validation: {

          },
          date: {
            shortcuts: [{
              text: '+ 1 heure',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 heures',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 jour',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 jours',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 semaine',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 semaines',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 3 semaines',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 3 * 7 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 1 mois',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }, {
              text: '+ 2 mois',
              onClick (picker) {
                const date = new Date()
                date.setTime(date.getTime() + 2 * 30 * 24 * 60 * 60 * 1000)
                picker.$emit('pick', date)
              }
            }]
          }
        },
        form: {
          date: null,
          user_id: this.$store.getters['users/current'].id
        },
        button: {
          loading: false,
          text: 'Modifier les rappels'
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      events.on('app/reminder/move', ({ids}) => {
        self.ids = ids
        self.visible = true
      })
    },
    methods: {
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            self.button.loading = true

            let promise = new Promise((resolve, reject) => {
              resolve()
            })

            let form = {}
            if (this.form.date) form.date = this.form.date
            if (this.form.user_id) form.user_id = this.form.user_id

            for (let i = 0; i < self.ids.length; i++) {
              promise = promise.then(() => {
                self.button.text = 'Modification (' + i + ' / ' + self.ids.length + ')'
                return self.$model.reminder.api().update(self.ids[i], form)
              })
            }

            promise.then(() => {
              self.button.loading = false
              self.button.text = 'Modifier les rappels'
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      },
      users () {
        return this.$store.getters['users/all']
      },
      categories () {
        return this.$store.getters['reminder_categories/all']
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MoveRemindersModal.vue?d1ca7c5c